import { components } from 'type/ReportServiceSchema';

export type SentimentTopicDto = components['schemas']['SentimentTopic'];

export enum SentimentTopicModel {
  All = 'All',
  Advocacy = 'Advocacy',
  Communication = 'Communication',
  DiversityAndInclusion = 'Diversity & Inclusion',
  EmpowermentAndVoice = 'Empowerment and Voice',
  Growth = 'Growth',
  JobSecurity = 'Job Security',
  LeadershipAndPurpose = 'Leadership and Purpose',
  Manager = 'Manager',
  PayRewardsAndBenefits = 'Pay, Rewards & Benefits',
  RecognitionAndAppreciation = 'Recognition and Appreciation',
  SystemsToolsResources = 'Systems, Tools, Resources',
  Teamwork = 'Teamwork',
  Wellbeing = 'Wellbeing',
  WorkEnvironment = 'Work Environment',
  WorkLifeBalance = 'Work Life Balance',
  Other = 'Other',
}

export const mapSentimentTopicDtoToModel = (dto: SentimentTopicDto): SentimentTopicModel => {
  switch (dto) {
    case 'All':
      return SentimentTopicModel.All;
    case 'Advocacy':
      return SentimentTopicModel.Advocacy;
    case 'Communication':
      return SentimentTopicModel.Communication;
    case 'Diversity & Inclusion':
      return SentimentTopicModel.DiversityAndInclusion;
    case 'Empowerment and Voice':
      return SentimentTopicModel.EmpowermentAndVoice;
    case 'Growth':
      return SentimentTopicModel.Growth;
    case 'Job Security':
      return SentimentTopicModel.JobSecurity;
    case 'Leadership and Purpose':
      return SentimentTopicModel.LeadershipAndPurpose;
    case 'Manager':
      return SentimentTopicModel.Manager;
    case 'Pay, Rewards & Benefits':
      return SentimentTopicModel.PayRewardsAndBenefits;
    case 'Recognition and Appreciation':
      return SentimentTopicModel.RecognitionAndAppreciation;
    case 'Systems, Tools, Resources':
      return SentimentTopicModel.SystemsToolsResources;
    case 'Teamwork':
      return SentimentTopicModel.Teamwork;
    case 'Wellbeing':
      return SentimentTopicModel.Wellbeing;
    case 'Work Environment':
      return SentimentTopicModel.WorkEnvironment;
    case 'Work Life Balance':
      return SentimentTopicModel.WorkLifeBalance;
    case 'Other':
      return SentimentTopicModel.Other;
    default:
      console.warn(`Unknown SentimentTopic: ${dto}`);
      return SentimentTopicModel.Other;
  }
};
